/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from 'react';
import { AppProviders } from 'src/components/base/appProviders';
import { captureAttribution } from 'src/lib/captureAttribution';
import { initBranch } from 'src/lib/initBranch';
import { initSentry } from 'src/lib/initSentry';

// Used for the eligibility checker typeahead styling
import 'bootstrap/dist/css/bootstrap.min.css';

// Not currently using anything from the Bootstrap JS, but can add it in future
// import 'bootstrap/dist/js/bootstrap.min.js';
// import '@popperjs/core/dist/umd/popper.min.js';

// Tell CallRail to rescan the page for phone numbers on every page transition.
// https://apidocs.callrail.com/#dynamic-number-insertion
export const onRouteUpdate = ({ location }) => {
  window.CallTrk?.swap();

  window.branch?.track('pageview', {
    path: location.pathname,
  });

  captureAttribution(location.search);
};

export const onClientEntry = () => {
  initSentry();
  initBranch();
};

export const wrapRootElement = ({ element }) => <AppProviders>{element}</AppProviders>;
